import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppPermisions, Auth0Guard, AuthorizationGuard } from "./shared";

const routes: Routes = [
    {
        path: "callback",
        redirectTo: "application-definitions"
    },
    {
        path: "unauthorized",
        loadComponent: () =>
            import("./unauthorized/unauthorized.component").then(m => m.UnauthorizedComponent)
    },
    {
        path: "",
        loadChildren: () => import("./authorized/authorized.module").then(m => m.AuthorizedModule),
        canLoad: [Auth0Guard, AuthorizationGuard],
        canActivate: [Auth0Guard, AuthorizationGuard],
        data: {
            expectedPermissions: AppPermisions.readPermissions
        }
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
